// sequence räknar de visade turerna, index är platsen i data.messages. Analytikern
// pekar med sequence, domaren med index; de skiljer sig när en post saknar text.
export type TurnTarget = { sequence: number } | { index: number };

export const turnSelector = (target: TurnTarget): string =>
  'sequence' in target
    ? `[data-turn-sequence="${target.sequence}"]`
    : `[data-turn-index="${target.index}"]`;

export const scrollToTurn = (target: TurnTarget): void => {
  const el = document.querySelector(turnSelector(target));
  if (!(el instanceof HTMLElement) || typeof el.scrollIntoView !== 'function') return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.add('ring-2', 'ring-indigo-400');
  window.setTimeout(() => {
    el.classList.remove('ring-2', 'ring-indigo-400');
  }, 1800);
};
